/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import { colorClassNames } from '../../styles/Colors';

const IconEarthWorld = (props) => (
  <svg width={props.size} height={props.size} viewBox="0 0 36 36">
    <path className={colorClassNames.fill(props.color)} transform="translate(21.41 11.45)" id="icon-earth-world-a" d="M3.827 0v.284c0 1.161-.677 2.102-1.839 2.102a.739.739 0 0 0-.738.739v.53c0 .408.33.739.738.739h.361a.492.492 0 0 1 0 .985H.74A.739.739 0 0 0 0 6.117v.112c0 .408.33.739.739.739H2.48a1.194 1.194 0 1 1 0 2.388.739.739 0 0 0 0 1.477h2.922l1.18-4.695S5.228 2.311 5.228 2.197C5.228 2.083 3.827 0 3.827 0z" />
    <path className={colorClassNames.fill(props.color)} transform="translate(11.18 8.63)" id="icon-earth-world-b" d="M6.632 13.454c.957 0 1.733-.776 1.733-1.733v-.518c0-1.708-1.008-2.25-2.25-2.25H4.283a.542.542 0 1 1 0-1.083h.033a.708.708 0 1 0 0-1.417h-.074a.5.5 0 0 1 0-1h1.815a1.25 1.25 0 1 0 0-2.5h-.362C4.064 2.954 3.741 1.631 3.741 0L0 2.952v2.085a1 1 0 0 0 1 1h.042a.958.958 0 0 1 0 1.916h-.28A.762.762 0 0 0 0 8.716v2.559c0 .42.341.762.762.762s.762.341.762.762v4.456l2.218 1.349v-.66c0-.363.294-.657.658-.657a.658.658 0 0 0 .658-.658v-.6c0-.364.294-.659.658-.659a.658.658 0 0 0 .658-.658V13.65s.034-.197.258-.197z" />
    <path className={colorClassNames.fill(props.color)} transform="translate(8 8)" id="icon-earth-world-c" d="M19.25 10A9.25 9.25 0 0 1 10 19.25v1.5c5.937 0 10.75-4.813 10.75-10.75h-1.5zM10 19.25A9.25 9.25 0 0 1 .75 10h-1.5c0 5.937 4.813 10.75 10.75 10.75v-1.5zM.75 10A9.25 9.25 0 0 1 10 .75v-1.5C4.063-.75-.75 4.063-.75 10h1.5zM10 .75A9.25 9.25 0 0 1 19.25 10h1.5C20.75 4.063 15.937-.75 10-.75v1.5z" />
  </svg>
);
IconEarthWorld.propTypes = {
  size: PropTypes.any,
  color: colorClassNames.nameProp,
};
IconEarthWorld.defaultProps = {
  color: 'dark-neutral',
};

export default IconEarthWorld;
